import { ChangeEvent, useState } from "react";
import { Form } from "react-bootstrap";
import TextField from "@components/FormsV2/TextField/TextField";
import RequiredReactSelect from "@components/FormsV2/RequiredReactSelect/RequiredReactSelect";
import { EVENT_TYPE_OPTIONS } from "../types";
import type { EventType, WebhookSubscriptionFormValues } from "../types";

export interface WebhookSubscriptionFormProps {
  id: string;
  initialValues: WebhookSubscriptionFormValues;
  isSubmitting: boolean;
  onSubmit: (values: WebhookSubscriptionFormValues) => void;
}

export const WebhookSubscriptionForm = ({
  id,
  initialValues,
  isSubmitting,
  onSubmit,
}: WebhookSubscriptionFormProps): JSX.Element => {
  const [values, setValues] =
    useState<WebhookSubscriptionFormValues>(initialValues);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;
    onSubmit(values);
  };

  const selectedEvent =
    EVENT_TYPE_OPTIONS.find((o) => o.value === values.eventType) ?? undefined;

  return (
    <Form id={id} data-testid={id} onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-sm-4">
          <RequiredReactSelect
            label="Event"
            value={selectedEvent}
            onChange={(opt: any) =>
              setValues((p) => ({
                ...p,
                eventType: (opt?.value ?? "") as EventType | "",
              }))
            }
            options={EVENT_TYPE_OPTIONS}
            placeholder="Select…"
            required
          />
        </div>
        <div className="col-sm-8">
          <Form.Label htmlFor="webhook-url">Webhook URL</Form.Label>
          <TextField
            label={null}
            id="webhook-url"
            value={values.webhookUrl}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setValues((p) => ({ ...p, webhookUrl: e.target.value }))
            }
            placeholder="https://lorem.ipsum/hook"
            required
          />
          <small className="small text-muted d-block">
            Must accept a ContentType of application/vnd.api+json
          </small>
        </div>
      </div>
    </Form>
  );
};
